export default "__VITE_ASSET__W$v22oEZ__"